function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHomeFadeGradientMobile = function SvgHomeFadeGradientMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 540 540",
    style: {
      enableBackground: "new 0 0 540 540"
    }
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home-fade-gradient--mobile_svg__a",
    x1: "0%",
    x2: "0%",
    y1: "0%",
    y2: "100%",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#07271f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#002e22",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    style: {
      fill: "url(#home-fade-gradient--mobile_svg__a)"
    }
  }));
};
export default SvgHomeFadeGradientMobile;